import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { SecurityService } from '../../../services/security/security.service';

@Component({
  selector: 'app-ecommerce',
  imports: [CommonModule],
  templateUrl: './ecommerce.component.html',
})
export class EcommerceComponent {
  private router = inject(Router);
  private securityService = inject(SecurityService);

  navigateTo(path: string): void {
    this.router.navigate([path]);
  }

  /**
   * Verifica si el usuario NO debería ver la tarjeta de Usuarios
   * Retorna true si el usuario tiene ROLE_ADMIN_PUBLICIDAD o ROLE_AGENTE_PUBLICIDAD
   */
  get shouldHideUsuariosCard(): boolean {
    return this.securityService.hasAnyRole(['ROLE_ADMIN_PUBLICIDAD', 'ROLE_AGENTE_PUBLICIDAD']);
  }

  /**
   * Verifica si el usuario NO debería ver la tarjeta de Tarifas
   * Retorna true si el usuario tiene ROLE_AGENTE_PUBLICIDAD
   */
  get shouldHideTarifasCard(): boolean {
    return this.securityService.hasRole('ROLE_AGENTE_PUBLICIDAD');
  }

  /**
   * Verifica si el usuario NO debería ver la tarjeta de Programas
   * Retorna true si el usuario tiene ROLE_AGENTE_PUBLICIDAD
   */
  get shouldHideProgramasCard(): boolean {
    return this.securityService.hasRole('ROLE_AGENTE_PUBLICIDAD');
  }

  /**
   * Verifica si el usuario NO debería ver la tarjeta de Rubros
   * Retorna true si el usuario tiene ROLE_AGENTE_PUBLICIDAD
   */
  get shouldHideRubrosCard(): boolean {
    return this.securityService.hasRole('ROLE_AGENTE_PUBLICIDAD');
  }
}
